import React, {useState, useEffect} from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  makeStyles,
  CardHeader,
  Divider,
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';

import { SIREN_CONFIG } from "config.js";
import { loadRoomList, getRoomName, loadCaregiverList, getCaregiverValue, getCaregiverTelNo } from "utils/LoadConfiguration";
import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";



const PatientAddForm = (props) => {
  const { className, history, memberInfo,  ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();


	const [caregiverList, setCaregiverList] = useState([]);
	const [selectedCaregiver1_Id, setSelectedCaregiver1_Id] = useState(0);

	const [roomList, setRoomList] = useState([]);
	const [selectedRoomId, setSelectedRoomId] = useState('');
  const facility_id = useSelector((store) => store.user.facility_id);



  const handleSubmit = (event, values) => {
    event.preventDefault();

    fetch(`${SIREN_CONFIG.HOSTNAME}/patient/addPatient`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        patient_name: values.patient_name,
        patient_room_id: selectedRoomId,
        // patient_room_name: values.patient_room_name,
        patient_tel_no: values.patient_tel_no,
        patient_postcode: values.patient_postcode,
        patient_addr1: values.patient_addr1,
        patient_addr2: values.patient_addr2,
        protector1_name: values.protector1_name,
        protector1_tel_no: values.protector1_telno,
				caregiver1_Id: selectedCaregiver1_Id,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        if (responseData.resultCode === "000") {
          alert(formatMessage({id:'patient_add_successful'}));

          setTimeout(() => {
            history.goBack();
          }, 500);
        } else {
          //에러
          console.log(responseData.message);
          alert(`${formatMessage({id:'patient_add_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
        }
      })
      .catch((error) => {
        console.error(error);
        alert(`${formatMessage({id:'patient_add_failed'})}\n${responseData.message}`);
      });
  };

  const handleBack = () => {
    history.goBack();
  };


	useEffect(()=> {

    async function loadCaregiverInfo(){
      setCaregiverList( await loadCaregiverList(facility_id ) );
    }
    loadCaregiverInfo();

    setSelectedRoomId('');

    async function loadRoomInfo() {
      const list = await loadRoomList(facility_id);
      setRoomList(list);
    }
    loadRoomInfo();

	},[]);


  return (

    <Formik
      initialValues={{
        patient_name: "",
        patient_room_name: "",
        patient_tel_no: "",
        patient_postcode: "",
        patient_addr1: "",
        patient_addr2: "",
        protector1_name: "",
        protector1_telno: "",
				caregiver1_Id: "",
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        touched,
        values,
      }) => {
          return (
            <form
              className={clsx(classes.root, className)}
              onSubmit={(e) => handleSubmit(e, values)}
            >
              <Card>
                <CardHeader
                  className={classes.card_header}
                  title={formatMessage({ id: 'patient_add' })}
                  titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4' }} />


                <CardContent>
                  <Grid container spacing={2}>

                    <Grid item lg={4} xs={12}>
                      <TextField
                        error={Boolean(touched.patient_name && errors.patient_name)}
                        fullWidth
                        helperText={touched.patient_name && errors.patient_name}
                        label={formatMessage({ id: 'patient_name' })}
                        name="patient_name"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        required
                        value={values.patient_name}
                        variant="outlined"
                        inputProps={{ maxLength: 10 }} />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <Autocomplete
                        id="select-room"
                        options={roomList}
                        classes={{ option: classes.options }}
                        autoHighlight
                        getOptionLabel={(option) => (option.roomName ? option.roomName : "")}
                        getOptionSelected={(option, value) => option.roomName === value.roomName}
                        value={getRoomName(selectedRoomId)}
                        renderOption={(option) => (
                          <React.Fragment>
                            {option.roomName}
                          </React.Fragment>
                        )}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={formatMessage({ id: 'emergency_history_select_room' })}
                            variant="outlined"
                            required
                            inputProps={{
                              ...params.inputProps
                            }} />
                        )}

                        onChange={(event, newValue) => {
                          if (newValue && newValue.roomId) {
                            setSelectedRoomId(newValue.roomId);
                          }
                        } } />
                    </Grid>

                    <Grid item md={4} xs={12}>
                      <TextField
                        error={Boolean(touched.patient_tel_no && errors.patient_tel_no)}
                        fullWidth
                        helperText={touched.patient_tel_no && errors.patient_tel_no}
                        label={formatMessage({ id: 'patient_tel' })}
                        name="patient_tel_no"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.patient_tel_no}
                        variant="outlined"
                        inputProps={{ maxLength: 20 }} />
                    </Grid>


                    <Grid item md={2} xs={12}>
                      <TextField
                        error={Boolean(touched.patient_postcode && errors.patient_postcode)}
                        fullWidth
                        helperText={touched.patient_postcode && errors.patient_postcode}
                        label={formatMessage({ id: 'patient_postcode' })}
                        name="patient_postcode"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.patient_postcode}
                        variant="outlined"
                        inputProps={{ maxLength: 5 }} />
                    </Grid>

                    <Grid item md={5} xs={12}>
                      <TextField
                        error={Boolean(touched.patient_addr1 && errors.patient_addr1)}
                        fullWidth
                        helperText={touched.patient_addr1 && errors.patient_addr1}
                        label={formatMessage({ id: 'patient_addr1' })}
                        name="patient_addr1"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.patient_addr1}
                        variant="outlined"
                        inputProps={{ maxLength: 100 }} />
                    </Grid>

                    <Grid item md={5} xs={12}>
                      <TextField
                        error={Boolean(touched.patient_addr2 && errors.patient_addr2)}
                        fullWidth
                        helperText={touched.patient_addr2 && errors.patient_addr2}
                        label={formatMessage({ id: 'patient_addr2' })}
                        name="patient_addr2"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.patient_addr2}
                        variant="outlined"
                        inputProps={{ maxLength: 100 }} />
                    </Grid>



                    <Grid item lg={12} xs={12}>
                      <Divider className={classes.divider} />

                      <CardHeader
                        className={classes.card_sub_header}
                        title={formatMessage({id:'protector_info'})}
                        titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h5' }} />
                    </Grid>


                    <Grid container item spacing={2}>
                      <Grid item lg={3} xs={12}>
                        <TextField
                          error={Boolean(touched.protector1_name && errors.protector1_name)}
                          fullWidth
                          helperText={touched.protector1_name && errors.protector1_name}
                          label={formatMessage({id:'protector_name'})}
                          name="protector1_name"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.protector1_name}
                          variant="outlined"
                          inputProps={{ maxLength: 10 }} />
                      </Grid>

                      <Grid item md={3} xs={12}>
                        <TextField
                          error={Boolean(touched.protector1_telno && errors.protector1_telno)}
                          fullWidth
                          helperText={touched.protector1_telno && errors.protector1_telno}
                          label={formatMessage({id:'protector_tel'})}
                          name="protector1_telno"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.protector1_telno}
                          variant="outlined"
                          inputProps={{ maxLength: 20 }} />
                      </Grid>

                      <Grid item md={6} xs={12} />
                    </Grid>


                    <Grid item md={12} xs={12}>
                      <Divider className={classes.divider} />
                      <CardHeader
                        className={classes.card_sub_header}
                        title={formatMessage({id:'patient_caregiver_info'})}
                        titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h5' }} />
                    </Grid>

                    <Grid container item spacing={2}>
                      <Grid item md={3} xs={12}>

                        <Autocomplete
                          id="caregiver1"
                          options={caregiverList}
                          autoHighlight
                          getOptionLabel={(option) => option.caregiverName ? option.caregiverName : ""}
                          getOptionSelected={(option, value) => option.caregiverName === value.caregiverName}
                          value={getCaregiverValue(selectedCaregiver1_Id)}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label={formatMessage({id:'patient_select_caregiver'})}
                              variant="outlined"
                              fullWidth
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: 'new-password'
                              }} />
                          )}

                          onChange={(event, newValue) => {
                            if (newValue && newValue.caregiverId) {
                              setSelectedCaregiver1_Id(newValue.caregiverId);
                            }
                          } } />

                      </Grid>

                      <Grid item md={3} xs={12}>
                        <TextField
                          InputLabelProps={{ shrink: true }}
                          disabled
                          fullWidth
                          label={formatMessage({id:'patient_caregiver_tel'})}
                          name="caregiver1_telno"
                          value={getCaregiverTelNo(selectedCaregiver1_Id)}
                          variant="outlined"
                          inputProps={{ maxLength: 20 }} />
                      </Grid>

                      <Grid item md={6} xs={12} />
                    </Grid>

                  </Grid>

                  <Divider className={classes.divider} />

                  <Grid item className={classes.action}>

                    <Button
                      variant="contained"
                      color="primary"
                      type="submit"
                      size="large"
                      disabled={isSubmitting}
                      className={classes.action}
                    >
                      <FormattedMessage id="patient_add" />
                    </Button>

                    <Button
                      variant="outlined"
                      size="large"
                      onClick={handleBack}
                      className={classes.action}
                    >
                      <FormattedMessage id="cancel" />
                    </Button>
                  </Grid>
                </CardContent>
              </Card>
            </form>
          );
        }}
    </Formik>
  );
};

PatientAddForm.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};

export default PatientAddForm;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },

  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  card_sub_header : {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.grey.main,

    marginTop: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2)
  }
}));
